export function ResolveXeroContactsCtrl ($scope, $state, $translate, workshopAPI, contacts, count, messages) {
  $scope.contacts = contacts || [];
  $scope.loaded = true;
  
  $scope.currentPage = BigDecimal.ONE;
  $scope.count = new BigDecimal(count.toString());
  
  $scope.firstPage = function () {
    return $scope.currentPage.equals(BigDecimal.ONE);
  };
  
  $scope.lastPage = function () {
    var lastPage = $scope.count.divide(BigDecimal.TEN, 2, BigDecimal.ROUND_HALF_UP).setScale(0, BigDecimal.ROUND_CEILING)
    return $scope.currentPage.equals(lastPage);
  };
  
  $scope.contactType = function (type, contact) {
    var types = { customer: 'C', vendor: 'V' };
    
    return types[type] === contact.contact_type;
  };
  
  ($scope.addDefaults = function(contacts) {
    angular.forEach(contacts, function (contact) {
      contact.contact_type = 'C';
      contact.cash_or_account = $scope.company.default_cash_or_account;
    });
  })(contacts);
  
  $scope.back = function() {
    $scope.save().then(function(data) {
      $scope.currentPage = BigDecimal.ONE.max($scope.currentPage.subtract(BigDecimal.ONE));
      $scope.getPage($scope.currentPage);
    }, function (err) {
      messages.error(err);
    });
  };
  
  $scope.process = function() {
    var process = function () {
      return workshopAPI.get('/temporary_xero_contacts/process_contacts');
    };
    
    $scope.processing = true;
    
    $scope.save().then(process).then(function (data) {
      $scope.form.$setPristine();
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
      $state.go('app');
    }, function (err) {
      messages.error(err);
    }, function () {
      $scope.processing = false;
    });
  };
  
  $scope.next = function() {
    $scope.save().then(function(data) {
      $scope.currentPage = $scope.currentPage.add(BigDecimal.ONE);
      $scope.getPage($scope.currentPage);
    }, function (err) {
      messages.error(err);
    });
  };
  
  $scope.save = function() {
    return workshopAPI.patch('/temporary_xero_contacts', $scope.contacts, 'contacts');
  };
  
  $scope.getPage = function(page) {
    workshopAPI.get('/temporary_xero_contacts', [ BigDecimal.TEN.multiply(page.subtract(BigDecimal.ONE)).toString(), 10 ])
    .then(function (contacts) {
      $scope.contacts = contacts;
      $scope.addDefaults($scope.contacts);
    }, function (err) {
      messages.error(err);
    });
  };
}